module.exports = {
  1212: { api: 1212, human: 'monatlich', months: 1 },
  412: { api: 412, human: 'vierteljährlich', months: 3 },
  212: { api: 212, human: 'halbjährlich', months: 6 },
  112: { api: 112, human: 'jährlich', months: 12 }
}
